var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBancor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Bancor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bancor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 102,
    height: 102,
    rx: 32,
    fill: "#000D2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 97C77.0767 97 97 77.0767 97 52.5C97 27.9233 77.0767 8 52.5 8C27.9233 8 8 27.9233 8 52.5C8 77.0767 27.9233 97 52.5 97Z",
    fill: "#000D2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2775 24.3538L39.7118 31.7157L52.2775 39.0805L65.0796 31.7157L52.2775 24.3538ZM54.344 63.664V78.3907L71.4125 68.6535V53.924L54.344 63.664ZM67.1461 36.3465V51.076L54.3412 58.4408V43.7113L67.1461 36.3465ZM36.3242 51.076L49.1291 58.4408V43.7113L36.3242 36.3465V51.076ZM36.3242 71.0287L49.1291 78.3907V63.664L36.3242 56.302V71.0259V71.0287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancor);
export default __webpack_public_path__ + "static/media/bancor.55210b0fe9e76d0078be5cd8b23d3557.svg";
export { ForwardRef as ReactComponent };